// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_AvailableExpensesResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for available_expenses /payroll/available_expenses
 * Returns array of available despesas for linking to a payroll period
 */
import type { Despesas_GetAvailableDespesasForPayrollPeriodRow } from './Despesas_GetAvailableDespesasForPayrollPeriodRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Payroll_AvailableExpensesResponseDados = Despesas_GetAvailableDespesasForPayrollPeriodRow[];

export type Payroll_AvailableExpensesResponse = ApiResponse<Payroll_AvailableExpensesResponseDados>;

registerResponseContract('Payroll_AvailableExpensesResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      despesa_id:                        { type: 'number',  required: true },
      despesa_franquia_id:               { type: 'number',  required: true },
      status:                            { type: 'string',  required: false },
      despesa_status_id:                 { type: 'number',  required: true },
      categoria:                         { type: 'string',  required: false },
      categoria_raw:                     { type: 'string',  required: true },
      despesa_titulo:                    { type: 'string',  required: true },
      despesa_valor:                     { type: 'number',  required: true },
      despesa_tipo_mensal:               { type: 'number',  required: true },
      despesa_descricao:                 { type: 'string',  required: false },
      despesa_data_vencimento:           { type: 'string',  required: false },
      despesa_data_lancamento:           { type: 'string',  required: true },
      data_vencimento:                   { type: 'string',  required: false },
      data_lancamento:                   { type: 'string',  required: true },
      parcela:                           { type: 'string',  required: true },
      despesa_generated_from_payroll:    { type: 'number',  required: true },
      despesa_generated_from_payroll_id: { type: 'number',  required: false },
      despesa_payroll_period_id:         { type: 'number',  required: false },
      franquia:                          { type: 'string',  required: false },
    },
  },
})
